// Firestore Collection Names
export const COLLECTIONS = {
    TENANTS: 'tenants',
    WAREHOUSES: 'warehouses',
    DOCKS: 'docks',
    VEHICLE_TYPES: 'vehicleTypes',
    LOADING_RATES: 'loadingRates',
    TRANSPORTERS: 'transporters',
    TRANSPORTER_TYPES: 'transporterTypes',
    VEHICLES: 'vehicles',
    USERS: 'users',
    NOTIFICATIONS: 'notifications',
    RESERVATION_SLOTS: 'reservationSlots',
    DRIVERS: 'drivers',

    // Master Data
    COMPANIES: 'companies',
    FACTORIES: 'factories',
    DOOR_GROUPS: 'doorGroups',

    // System Configuration
    SYSTEM_CONFIGS: 'systemConfigs',

    // Logging
    VEHICLE_MOVEMENT_LOGS: 'vehicleMovementLogs',
    RESERVATION_WORKFLOW_LOGS: 'reservationWorkflowLogs',
    TENANT_USERS: 'users'
};
